import { zodFormData } from '../../zod/formData';
import { ParsedDate } from '../parsed/parsedDate';
import z from 'zod';

export const ImageClassificationModelEnvironment = z.enum(['Cloud', 'Cart']);
export type ImageClassificationModelEnvironment = z.infer<typeof ImageClassificationModelEnvironment>;

export const ImageClassificationModel = z.object({
    id: z.string(),
    network: z.string(),
    environments: z.array(ImageClassificationModelEnvironment).nullish(),
    blobPath: z.string().nullish(),
    cdnRelativePath: z.string().nullish(),
    md5Hash: z.string().nullish(),
    fileName: z.string(),
    fileSize: z.number().int().nonnegative().nullish(),
    storeGuids: z.array(z.string()).nullish(),
    createdBy: z.string(),
    modifiedBy: z.string(),
    deletedBy: z.string().nullish(),
    createdOn: ParsedDate,
    modifiedOn: ParsedDate,
});
export type ImageClassificationModel = z.infer<typeof ImageClassificationModel>;

export const ImageClassificationModelUploadRequest: z.ZodCustom<FormData, FormData> = zodFormData({
    file: z.file(),
    network: z.string(),
});
export type ImageClassificationModelUploadRequest = z.infer<typeof ImageClassificationModelUploadRequest>;

export const ImageClassificationModelUpdateRequest = z.object({
    id: z.string(),
    storeGuids: z.string().array().nullish(),
    environments: z.array(ImageClassificationModelEnvironment).nullish(),
});
export type ImageClassificationModelUpdateRequest = z.infer<typeof ImageClassificationModelUpdateRequest>;

export const ImageClassificationModelConfigs = z.object({
    maxCartModelSize: z.number().int().nonnegative(),
    objectDetection: z.object({
        classNames: z.string().array(),
    }),
});

export type ImageClassificationModelConfigs = z.infer<typeof ImageClassificationModelConfigs>;
